import React, { FC } from 'react'

import { Field } from 'redux-form'

import { IconButton } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

import SortMenu from '~/components/menu/SortMenu'
import Flexbox from '~/components/shared/Flexbox'
import Text from '~/components/shared/Text'

import { useDesktop } from '~/hooks/responsive'

import GridIcon from '~/assets/icons/grid.svg?sprite'
import ListIcon from '~/assets/icons/list.svg?sprite'
import SortIcon from '~/assets/icons/sort.svg?sprite'

import SearchToolBox from './SearchToolBox'

type Props = {
  orientation: 'grid' | 'list'
  changeOrientation: (o: 'grid' | 'list') => void
}

const SearchToolBar: FC<Props> = ({ orientation, changeOrientation }) => {
  const theme = useTheme()
  const isDesktop = useDesktop()

  return (
    <SearchToolBox justifyContent="space-between">
      <Flexbox alignItems="center">
        <SortIcon width={14} height={14} />
        <Text mx={2}>Sort by:</Text>
        <Field
          name="sorting"
          defaultValue="newest"
          component={({ input, defaultValue }) => (
            <SortMenu
              value={input.value || defaultValue}
              onChange={(value) => {
                if (value !== defaultValue) {
                  input.onChange(value)
                } else if (value) {
                  input.onChange(null)
                }
              }}
            />
          )}
        />
      </Flexbox>
      {isDesktop && (
        <Flexbox>
          <IconButton onClick={() => changeOrientation('list')}>
            <ListIcon
              stroke={
                orientation === 'list'
                  ? theme.palette.primary.main
                  : theme.palette.text.primary
              }
            />
          </IconButton>
          <IconButton onClick={() => changeOrientation('grid')}>
            <GridIcon
              stroke={
                orientation === 'grid'
                  ? theme.palette.primary.main
                  : theme.palette.text.primary
              }
            />
          </IconButton>
        </Flexbox>
      )}
    </SearchToolBox>
  )
}

export default SearchToolBar
